export default __webpack_public_path__ + "static/media/sgj-english.154abbeb.svg";